module.exports = __webpack_public_path__ + "static/media/show-gal-1.7c956d7d.jpg";